export default {
    rootElementId: 'networkapp',
    basePath: 'https://app.nwa-staging.nl/',
    //
    // API
    apiURL: 'https://api.nwa-staging.nl',
    socketURL: 'https://socketio.nwa-staging.nl',
    clientId: 'web-code',
    // forceUpdateInterval: 10000, // for debugging purposes; leave commented out to use update_interval_seconds from API/updates
    //
    // linkedin
    linkedinAppId: "78smvew4ohiqqg",
    linkedinScope: ['profile','email'],
    linkedinCallback: "https://api.nwa-staging.nl/oauth_redirect",
    //
    // apple id
    appleClientId: 'com.networkapp.online',
    appleRedirectURI: 'https://app.nwa-staging.nl/apple-signin-complete',
    //
    // Support email address
    supportAddress: 'support@networkapp.eu',
    //
    // Sentry
    sentryId: 'https://84e04400a28cb99c72831d7fe0afb280@o4507101435723776.ingest.de.sentry.io/4507169739178064',
    //
    // Pushwoosh notifications
    pushwooshApplicationCode: '069DF-3D925',
    pushwooshDebugLevel: 'debug',
    firebaseID: '66073274599',
    //
    // Push notifications
    publicVapidKey: 'BBhgzVBEx4uGysCtCIUApa1ynPS-zC9LpeawgWaOENIbYkJvy7yX4VPPwi-KWgbOwzpZcBp5BKTkhoNhkVXvRYY',
    //
    // deactivate some features
    disableNonNativeDialogs: false,
};
